import { Paragraph } from '@zillow/constellation-10';

const VerificationCompletePage = (): JSX.Element | null => (
  <>
    <Paragraph textStyle="body-lg-bold">Thanks! You&apos;ve answered your verification questions.</Paragraph>
    <Paragraph>
      The info you provided will help keep our service secure. You&apos;re almost done with your setup.
    </Paragraph>
  </>
);

export default VerificationCompletePage;
